/**
 * Client entry point.
 *
 * App.css is imported here and nowhere else - it is the project's only
 * stylesheet, and a second import site is the first step towards a second file.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import { AuthProvider } from './lib/auth-context.jsx';
import { FavoritesProvider } from './lib/favorites-context.jsx';
import { ListsProvider } from './lib/lists-context.jsx';
import { ShortlistProvider } from './lib/shortlist-context.jsx';
import './App.css';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        {/* Inside AuthProvider: the shortlist, favorites and lists are all
            per-user and must clear on sign-out, so each needs to see the session. */}
        <ShortlistProvider>
          <FavoritesProvider>
            <ListsProvider>
              <App />
            </ListsProvider>
          </FavoritesProvider>
        </ShortlistProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
